import { Text, Box, Icon, Tooltip } from '@nimbus-ds/components';
import { IaCoinIcon } from '@nimbus-ds/icons';
import { useTranslationCommon } from 'commons/hooks';

interface AiCreditsBadgeProps {
  remainingAiUses: number;
}

function AiCreditsBadge({
  remainingAiUses,
}: Readonly<AiCreditsBadgeProps>): JSX.Element {
  const t = useTranslationCommon('aiGeneration');

  const badgeContent = (
    <Box
      display="flex"
      alignItems="center"
      gap="1"
      paddingX="2"
      paddingY="0-5"
      borderRadius="2"
      borderColor={{
        xs: 'transparent',
        hover: 'neutral-surfaceHighlight',
      }}
      borderWidth="1"
      borderStyle="solid"
      role="status"
    >
      <Icon source={<IaCoinIcon size="small" />} color="ai-generative" />
      <Text fontSize="caption" color="primary-textLow" fontWeight="medium">
        {remainingAiUses === -1 ? t('unlimitedCredits') : remainingAiUses}
      </Text>
    </Box>
  );

  return (
    <Tooltip content={t('creditsLeft')} position="top" arrow>
      {badgeContent}
    </Tooltip>
  );
}

export default AiCreditsBadge;
